import { List, Row, Typography } from "antd";
import { ProviderExtendedCommonObj } from "../../constants/ProviderConstants";
import ChannelsPageServiceTitle from "./ChannelsPageServiceTitle";

const commonInfoIconClass = "service-not-authoirzed-common-info-icon";
export default function ServiceNotAuthorizedPanel({ appProperties, serviceName, rightServiceObj }) {
  return (
    <>
      <div className="bg-white hs-border-grey hs-border-6 pb-lg-4 overflow-auto w-100 hs-py-4 hs-lg-h-700-px">
      <List
        split={false}
        itemLayout="horizontal"
        dataSource={ProviderExtendedCommonObj?.[rightServiceObj?.rightServiceName]?.AuthorizeReference}
        size="small"
        renderItem={(item) => (
          <List.Item>
            <List.Item.Meta
              avatar={
                <div className="service-not-authoirzed-common-info-icon-container">
                  <div className={`staticIconsSprite ${item.iconClassName || commonInfoIconClass}`} />
                </div>
              }
              description={
                <div className="d-flex">
                  <div className={`hs-text hs-fw-400 hs-fs-12`}>
                    {item.title ? <b className="hs-fw-500 hs-fs-13">{item.title}: </b> : ""}
                    {item.description}
                  </div>
                </div>
              }
            />
          </List.Item>
        )}
      />
      <Row justify={"center"}>
        <div className="hs-w-95 d-flex flex-column gap-4">
          {ProviderExtendedCommonObj?.[rightServiceObj?.rightServiceName]?.AuthorizeReferenceText && (
            <Typography
              style={{
                fontSize: "14px",
              }}
              className="hs-text"
            >
              {ProviderExtendedCommonObj?.[rightServiceObj?.rightServiceName]?.AuthorizeReferenceText ?? []}
            </Typography>
          )}
          <div className="d-flex justify-content-center w-100">
            {ProviderExtendedCommonObj?.[rightServiceObj?.rightServiceName]?.AuthorizeReferenceURL && (
              <iframe
                className="hs-iframe-help-video"
                width="95%"
                height="300"
                src={ProviderExtendedCommonObj?.[rightServiceObj?.rightServiceName]?.AuthorizeReferenceURL + "?rel=0" ?? []}
                frameBorder={10}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="YouTube video"
              ></iframe>
            )}
          </div>
        </div>
      </Row>
        </div>
    </>
  );
}

ServiceNotAuthorizedPanel.Title = Title;

function Title({ serviceName, appProperties }) {
  return (
    <ChannelsPageServiceTitle
      removeTitleIcon={true}
      appProperties={appProperties}
      serviceName={serviceName}
      title={appProperties?.providerCommonObj?.serviceAuthorizationPageRightPanelTitle}
    />
  );
}
